import { DocumentPickerAsset } from "expo-document-picker";
import { isDocumentPickerAsset, ThrelsFileType } from "ui/types/ThrelsFileType";

const MAX_SIZE_BYTES = 10 * 1024 * 1024; // 10MB

export function convertToFile(uploadedFiles: DocumentPickerAsset[]): File[] {
  return uploadedFiles.flatMap((asset) => asset.file).filter((file) => !!file);
}

export const getFileExtension = (path?: string): string => {
  if (!path) return "";
  // Handle both URLs and file paths
  const filename = path.split(/[#?]/)[0]; // Remove query params and hash
  const extension = filename?.split(".").pop()?.toLowerCase() || "";
  return extension;
};

export const validateAsset = (
  asset: ThrelsFileType,
  allowedExtensions: string[],
) => {
  // Only validate DocumentPickerAsset items
  if (!("name" in asset) || !isDocumentPickerAsset(asset))
    throw new Error("We were unable to determine the file type");

  const name = asset.name;
  const size = asset.size;
  const mime = asset.mimeType || "";

  const ext = getFileExtension(asset.name);

  // Check type: allow if extension OR mime matches any provided allowedExtensions entry
  const isTypeAllowed =
    (ext && allowedExtensions.includes(ext)) ||
    (mime && allowedExtensions.includes(mime.toLowerCase()));

  if (!isTypeAllowed) {
    throw new Error(
      `File ${name ?? ""} has an invalid type. Allowed: ${allowedExtensions.join(", ")}`,
    );
  }

  // Check size if available
  if (typeof size === "number" && size > MAX_SIZE_BYTES) {
    throw new Error(`File ${name ?? ""} exceeds the 10MB size limit`);
  }
};
